var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0.125C6.08562 0.125 5.75 0.460625 5.75 0.875V1.25H0.875C0.461 1.25 0.125 1.586 0.125 2C0.125 2.414 0.461 2.75 0.875 2.75H1.31006L2.26294 14.1868C2.35894 15.3436 3.34461 16.25 4.50561 16.25H11.4944C12.6554 16.25 13.6407 15.3436 13.7371 14.1868L14.6899 2.75H15.125C15.539 2.75 15.875 2.414 15.875 2C15.875 1.586 15.539 1.25 15.125 1.25H10.25V0.875C10.25 0.460625 9.91437 0.125 9.5 0.125H6.5ZM2.81519 2.75H13.1855L12.2422 14.0623C12.2099 14.4478 11.8821 14.75 11.4951 14.75H4.50561C4.11824 14.75 3.78969 14.4478 3.75781 14.0623L2.81519 2.75Z",
    fill: "#55535B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTrash);
export default __webpack_public_path__ + "static/media/ic_trash.95fbd270367716f52076b13fc0c6ef99.svg";
export { ForwardRef as ReactComponent };